// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__WL1uO","search":"Settings_search__21xHv","filter":"Settings_filter__35w5d"};